<template :key="jpoUrl">
  <div v-if="!jpoUrl" class="disc">
    <router-link
      :to="{ name: 'Configurator', params: { type: 'configurator' } }"
      class="disc__half -blue"
    >
      <i class="icone icon-configurateur3d"></i>
      <span>
        <span class="fw-bold">{{ getTranslation(283) }}</span
        ><br />
        {{ getTranslation(499) }}
      </span>
    </router-link>
    <router-link :to="{ name: 'Models' }" class="disc__half -red">
      <i class="icone icon-picto-concevez"></i>
      <span>
        <span class="fw-bold">{{ getTranslation(500) }}</span
        ><br />
        {{ getTranslation(501) }}
      </span>
    </router-link>
    <div class="disc__line"></div>
    <div class="disc__center">
      <div class="disc__center -inside"></div>
    </div>
  </div>
  <div v-else class="disc-container">
    <div class="disc -third">
      <router-link
        :to="{ name: 'Configurator', params: { type: 'configurator' } }"
        class="disc__third --1"
      >
        <i class="icone icon-configurateur3d"></i>
        <span>
          <span class="fw-bold">{{ getTranslation(283) }}</span
          ><br />
          {{ getTranslation(499) }}
        </span>
      </router-link>
      <router-link
        :to="{ name: 'JPO', params: { type: 'jpo' } }"
        class="disc__third --2"
      >
        <i class="icone icon-tv-light"></i>
        <span>
          <span class="fw-bold">{{ getTranslation(532) }}</span>
        </span>
      </router-link>
      <router-link :to="{ name: 'Models' }" class="disc__third --3">
        <i class="icone icon-picto-concevez"></i>
        <span>
          <span class="fw-bold">{{ getTranslation(500) }}</span
          ><br />
          {{ getTranslation(501) }}
        </span>
      </router-link>
      <div class="disc__thirdLine --1"></div>
      <div class="disc__thirdLine --2"></div>
      <div class="disc__thirdLine --3"></div>
      <div class="disc__center">
        <div class="disc__center -inside"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTranslation } from "@/services/translation-manager";
import { mapState } from "pinia";
import { useMainStore } from "@/store";

export default {
  name: "HomeView",
  computed: {
    ...mapState(useMainStore, {
      jpoUrl: (state) => state.jpoUrl,
    }),
  },
  methods: {
    getTranslation(id) {
      return getTranslation(id);
    },
  },
};
</script>

<style lang="scss" scoped>
$size: 614px;
$padding: 20px;
$border-radius: calc(($size - 2 * $padding) / 2);

.disc-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: $size;
  height: $size;
  border: $padding solid $white;
  border-radius: 50%;
}

.disc {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: $white;
  width: $size;
  height: $size;
  border-radius: 50%;
  padding: $padding;

  &.-third {
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    transform: none;
    width: calc($size - $padding * 2);
    height: calc($size - $padding * 2);
  }

  &__half {
    width: 100%;
    height: 50%;
    border-radius: $border-radius $border-radius 0 0;
    background: $light-blue;
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    padding-top: 45px;
    border: none;
    font-size: 28px;
    line-height: 1.14;

    &.-red {
      background: $red;
      border-radius: 0 0 $border-radius $border-radius;
      color: $white;
      padding-top: 100px;

      .icone {
        font-size: 62px;
      }
    }

    &.-blue {
      color: $blue;
    }
  }

  &__third {
    background: $light-blue;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-size: 25px;
    line-height: 1.14;
    text-align: center;

    &.--2 {
      left: 50%;
      transform: translateX(-50%);
      height: 50%;
      top: initial;
      z-index: 1;
      background: none;
      color: $white;
      padding-top: 50px;

      &:after {
        background: $blue;
        width: 110%;
        height: 110%;
        position: absolute;
        top: 50px;
        left: 50%;
        content: "";
        z-index: -1;
        transform: translateX(-50%) rotate(45deg);
        transform-origin: center center;
      }
    }

    &.--3 {
      background: $red;
      transform: none;
      right: 0;
      left: initial;
      padding-bottom: 90px;
      padding-left: 60px;

      .icone {
        font-size: 62px;
      }
    }
    &.--1 {
      background: $light-blue;
      color: $blue;
      transform: none;
      padding-bottom: 90px;
      padding-right: 60px;
    }
  }

  &__thirdLine {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: $padding;
    height: 50%;
    background: $white;
    z-index: 1;

    &.--2 {
      transform: rotate(45deg);
      transform-origin: bottom;
      left: 0;
      bottom: 25px;
      top: initial;
      height: 60%;
      width: $padding;
    }

    &.--3 {
      transform: rotate(-45deg);
      transform-origin: bottom;
      left: initial;
      right: 0;
      bottom: 25px;
      top: initial;
      height: 60%;
    }
  }

  .icone {
    font-size: 65px;
    margin-bottom: 15px;
  }

  &__line,
  &__center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &__line {
    background: $white;
    width: 100%;
    height: $padding;
  }

  &__center {
    width: 148px;
    height: 148px;
    background: $white;
    border-radius: 50%;
    z-index: 1;

    &.-inside {
      width: 128px;
      height: 128px;
      box-shadow: inset 0 0 40px 0 rgba(0, 0, 0, 0.16);
    }
  }
}
</style>
